import { PersonalLoanStoreService } from '@hb/modules/financial-obligations/personal-loan/personal-loan-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { CoApplicantPipe } from '@hb/modules/global';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { AdditionalInfoComponent, NextButtonComponent } from '@hb/modules';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApAmountInputComponent } from '@ap/input/amount';
import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'personal-loan-monthly-payment',
    imports: [ApAmountInputComponent, CoApplicantPipe, ApContentPipe, ReactiveFormsModule, AdditionalInfoComponent, NextButtonComponent],
    templateUrl: './personal-loan-monthly-payment.component.html',
    providers: [
        { provide: GLOBAL_STORE, useExisting: PersonalLoanStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.PERSONAL_LOAN_MONTHLY_PAYMENT }
    ]
})
export class PersonalLoanMonthlyPaymentComponent extends GlobalInjectComponent<PersonalLoanStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(PersonalLoanStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getMonthlyPayment()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((number) => this.store.setMonthlyPayment(number));
    }
}
